module.exports = __webpack_public_path__ + "img/presents.d37cf60d.png";